export const socialsData = {
    // github: 'https://github.com/',
    linkedIn: 'https://www.linkedin.com/in/sravan-vijayakumar-8378b2163/',
    instagram: 'https://www.instagram.com/sravan.vijayakumar/',
}